import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=70769a3e&scoped=true&"
import script from "./uploader.vue?vue&type=script&lang=js&"
export * from "./uploader.vue?vue&type=script&lang=js&"
import style0 from "./uploader.vue?vue&type=style&index=0&id=70769a3e&lang=scss&scoped=true&"
import style1 from "./uploader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70769a3e",
  null
  
)

export default component.exports